import logo from './logo.svg';
import './App.css';
import Navbar from './components/navbar';
import Presentazione from './components/presentazione';
import Body from './components/body';
import Footer from './components/footer';
import Prenotazione from './components/prenotazione';
import Negozio from './components/negozio';

import 'bootstrap/dist/css/bootstrap.min.css';

import { Component } from 'react';
import Posizione from './components/posizione';

class App extends Component {

  render(){
    return (
      <>
      
      <Navbar />

      <Presentazione />

      <Body />

      <Prenotazione />

      <Negozio />

      <Posizione />

      <Footer />
      
      </>
    
    );
  }
}

export default App;
